import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Edit from "../../../assets/images/editinput.svg";
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import {Select} from "@appkit4/react-components/select"
import PropTypes from "prop-types";
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp.js"
export default function BusinessImpactEdit(props) {
  const [rejectValue, setRejectValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const { sendRequest: reviewSelectedBusinessImpact } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const dropdownData = [{
    value: 0.1,
    label: "0.1"
  }, {
    value: 0.2,
    label: "0.2"
  }, {
    value: 0.3,
    label: "0.3"
  }, {
    value: 0.4,
    label: "0.4"
  }, {
    value: 0.5,
    label: "0.5"
  }, {
    value: 0.6,
    label: "0.6"
  }, {
    value: 0.7,
    label: "0.7"
  }, {
    value: 0.8,
    label: "0.8"
  }, {
    value: 0.9,
    label: "0.9"
  }, {
    value: 1,
    label: "1"
  }]
  let {
    updateBusinessAnalysis,
    getBusinessListData,
    View
  } = props;

  const handleReject = (value) => {
    setRejectValue(value);
  };
  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    let acceptRisk = {
      param_risk_id: updateBusinessAnalysis.risk_id,
      vendor_id: updateBusinessAnalysis.vendor_id,
      risk_comments: values.assessorComments,
      role_id: Number(sessionStorage.getItem("roleId")),
      created_by: Number(sessionStorage.getItem("userId")),
      param_manager_id: updateBusinessAnalysis.managerid,
      status: 1,
      email:sessionStorage.getItem("email"),
    };
    if (rejectValue != 4) {
      acceptRisk.approval_requestId = 2;
    } else {
      acceptRisk.approval_requestId = rejectValue;
    }
      try {
      reviewSelectedBusinessImpact(APIService.reviewSelectedBusinessImpact(acceptRisk), (result) => {
        if (result.CODE) {
          displayToastMessage(result.MSG, "success");
          setLoading(false);
          if (acceptRisk.approval_requestId === 2){
          let notifDataManager = {
            paramuserid: Number(sessionStorage.getItem("userId")),
            paramreqid: updateBusinessAnalysis.managerid,
            paramcontent: "Risk request approved by assessor",
            paramnextroleid: 2,
            paramcreatedby: Number(sessionStorage.getItem("roleId")),
            parammsgtype: result.MSG,
          };
          let notifDataBusinessUser = {
            paramuserid: Number(sessionStorage.getItem("userId")),
            paramreqid: updateBusinessAnalysis.business_owner,
            paramcontent: "Risk request approved by assessor",
            paramnextroleid: 1,
            paramcreatedby: Number(sessionStorage.getItem("roleId")),
            parammsgtype: result.MSG,
          }
          handleNotificationSubmitAPI(
            APIService.handleNotificationSubmit(notifDataBusinessUser),
            () => {}
          );
          handleNotificationSubmitAPI(
            APIService.handleNotificationSubmit(notifDataManager),
            () => {}
          );
        }
          else {
            let notifData = {
              paramuserid: Number(sessionStorage.getItem("userId")),
              paramreqid: updateBusinessAnalysis.business_owner,
              paramcontent: "Risk request rejected by assessor",
              paramnextroleid: 1,
              paramcreatedby: Number(sessionStorage.getItem("roleId")),
              parammsgtype: result.MSG,
            };
            handleNotificationSubmitAPI(
              APIService.handleNotificationSubmit(notifData),
              () => {}
            );
          }
          getBusinessListData();
          resetForm();
      props.sendBack();
        } else {
          setLoading(false);
          displayToastMessage("Something went wrong, Please try again!", "error");
        }
      })
    } catch (error) {
      console.log("Error", error);
      let Msg = "Action failed. Please try again!";
      displayToastMessage(Msg, "error");
    }
  };

  let validationSchema = Yup.object().shape({
    assessorComments: Yup.string()
      .required("Assessor Comments is Required")
      .matches(
        /^[()0-9a-zA-Z,. ]*$/,
        "Only alphabets and some special characters are allowed for this field "
      ),
  });

  function formatDate(date) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  return (
    <div>
      <div className="row text-right pt-3">
        <div className="col-md-12">
          <span
            className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
            onClick={props.sendBack}
          ></span>
        </div>
      </div>
      <Formik
        initialValues={{
          assessorComments: "",
        }}
        // onReset={handleReset}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {(prop) => {
          const {
            values,
            touched,
            errors,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
          } = prop;
          return (
            <div className="">
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Third Party Name <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field pl-1"
                          type="text"
                          placeholder="Please enter third party name"
                          name="thirdPartyName"
                          value={updateBusinessAnalysis.vendor_name}
                          disabled
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Information Classification <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          placeholder="Please enter information classification "
                          name="Infoclassification"
                          value={
                            updateBusinessAnalysis.information_classificationname
                          }
                          disabled
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Service Name <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field pl-1"
                          type="text"
                          name="Servicename"
                          placeholder="Please enter service name"
                          value={updateBusinessAnalysis.service_name}
                          disabled
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Over View of the Risk <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          placeholder="Please enter  over view of the risk "
                          name="riskOverView"
                          value={updateBusinessAnalysis.overview_oftherisk}
                          disabled
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Brief Description of <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field pl-1"
                          type="text"
                          placeholder="Please enter brief description of "
                          name="BriefDescription"
                          value={
                            updateBusinessAnalysis.business_descriptionof_service
                          }
                          disabled
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Control/Question <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          name="Contract"
                          placeholder="Please enter Contract that cannot be Meet "
                          value={updateBusinessAnalysis._contract}
                          disabled
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Business Owner <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          name="business_owner"
                          placeholder="Please enter business_owner"
                          value={updateBusinessAnalysis.business_owner_name}
                          disabled
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Domain/Area <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          placeholder="Please enter control domain"
                          name="BusinessOwner"
                          value={updateBusinessAnalysis.risk_domain}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Sub-Domain/Sub-Area <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          placeholder="Please enter control sub domain"
                          name="BusinessOwner"
                          value={updateBusinessAnalysis.risk_subdomain}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Probability of Occurrence <span className="asterisk-required">*</span>
                        </label>
                        <Select
                          showSearchOnToggle={true}
                          className="cv-input-field"
                          data={dropdownData}
                          value={Number(
                            updateBusinessAnalysis._probabilty_occurrence
                          )}
                          onSelect={(e) =>
                            handleChange("probabilty_occurrence")({
                              target: { value: e },
                            })
                          }
                          name="boarding"
                          placeholder="Select probability"
                          disabled
                        ></Select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Impact to Business <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          placeholder="Please enter impact to business"
                          name="BusinessOwner"
                          value={updateBusinessAnalysis._impact_business}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Date Logged <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          placeholder="Please date logged"
                          name="DateLogged"
                          value={formatDate(updateBusinessAnalysis.datelogged)}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Duration<span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          placeholder="Please enter duration"
                          name="duration"
                          value={updateBusinessAnalysis.duration}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Date Issued <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          placeholder="Please enter date issued"
                          name="DateIssued"
                          value={formatDate(updateBusinessAnalysis.date_issued)}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Expiry Date <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          name="duration"
                          placeholder="Please enter expiry date"
                          value={formatDate(
                            updateBusinessAnalysis.expiray_date
                          )}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Risk Rating <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          name="DateIssued"
                          placeholder="Please enter risk rating"
                          value={updateBusinessAnalysis._risk_rating}
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Assessor's Comments <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          name="comments"
                          placeholder="Please add comment "
                          value={values.assessorComments}
                          onChange={handleChange("assessorComments")}
                        />
                      </div>
                      {errors.assessorComments && touched.assessorComments && (
                        <div className="form-label error">
                          {errors.assessorComments}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Manager's Comments <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          type="text"
                          name="comments"
                          placeholder="No comments to show "
                          value={
                            updateBusinessAnalysis.approvalrejectioncomments
                          }
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div className="options-container">
                    {View && (
                      <button
                        className="save-button m-l-2"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        Accept
                      </button>
                    )}
                    {View && (
                      <button
                        type="submit"
                        className="save-button m-l-2"
                        onClick={() => handleReject(4)}
                      >
                        Reject
                      </button>
                    )}
                    <button
                      className="cancel-button m-l-2"
                      type="reset"
                      onClick={props.sendBack}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}
            </div>
          );
        }}
      </Formik>
    </div>
  );
}

BusinessImpactEdit.propTypes = {
  updateBusinessAnalysis: PropTypes.any,
  getBusinessListData: PropTypes.any,
  View: PropTypes.any,
  sendBack: PropTypes.any
}
